import Vue from 'vue'

const reportError = (err, extraContext = {}) => {
  try {
    if (window.DD_RUM && typeof window.DD_RUM.addError === 'function') {
      window.DD_RUM.addError(err, extraContext)
    }
  } catch (e) {
    // never let telemetry break the app
    console.warn('Error reporting to DD_RUM', e)
  }
}

const attachWindowHandler = (app) => {
  window.addEventListener('error', (event) => {
    const err = event.error || new Error(event.message)

    reportError(err, {
      source: 'window.onerror',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      route: app.router && app.router.currentRoute.fullPath,
      url: window.location.href
    })
  })

  window.addEventListener('unhandledrejection', (event) => {
    const err =
      event.reason instanceof Error
        ? event.reason
        : new Error(String(event.reason || 'unhandledrejection'))

    reportError(err, {
      source: 'unhandledrejection',
      route: app.router && app.router.currentRoute.fullPath,
      url: window.location.href
    })
  })
}

const overwriteConsoleError = (app) => {
  const origConsoleError = console.error.bind(console)

  console.error = (...args) => {
    try {
      const errArg = args.find(a => a instanceof Error)
      const err =
        errArg ||
        new Error(
          args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ')
        )

      reportError(err, {
        source: 'console.error',
        console_args: args,
        route: app.router && app.router.currentRoute.fullPath,
        url: window.location.href
      })
    } catch (_) {
      // ignore
    }

    return origConsoleError(...args)
  }
}

const resolveComponentName = (component) => {
  if (!component || !component.$options) {
    return 'anonymous'
  }

  if (component.$options.name) {
    return component.$options.name
  }

  if (component.$options._componentTag) {
    return component.$options._componentTag
  }

  return 'anonymous'
}

const attachVueListeners = (app) => {
  Vue.config.errorHandler = (err, vm, info) => {
    const componentName = resolveComponentName(vm)

    reportError(err, {
      vue_component: componentName,
      vue_info: info,
      route: app.router && app.router.currentRoute.fullPath,
      url: window.location.href,
      source: 'vue-error'
    })
    // force DD to send the error to the server
    window.dispatchEvent(new Event('pagehide'))
  }

  Vue.config.warnHandler = (msg, vm, trace) => {
    const componentName = resolveComponentName(vm)

    reportError(new Error(msg), {
      vue_component: componentName,
      vue_trace: trace,
      route: app.router && app.router.currentRoute.fullPath,
      url: window.location.href,
      source: 'vue-warn'
    })
  }
}

export default ({ app }) => {
  if (typeof window === 'undefined') {
    return
  }

  attachVueListeners(app)
  attachWindowHandler(app)
  overwriteConsoleError(app)
}
